import { Directive, Input } from '@angular/core';

@Directive({
  selector: '[height]',
  standalone: true,
  host: {
    '[style.min-height]': 'height',
    '[style.max-height]': 'height',
  }
})
export class heightDirective {

  @Input({ alias: 'height' }) height: string;
}
